/**
 * @author Pedro Antonio 
 * @type {RegExp} Regex para validación de correos
 * */
let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;

/**
* @author Pedro Antonio
* @description Function to replace letters áéíóúÁÉÍÓÚñÑ&
* @updatedDate 25-06-2024
* @param {String} text
* @returns {String}
*/
function replaceTextWithoutAccents(text) {
    const chars = {
        'á': 'a',
        'é': 'e',
        'í': 'i',
        'ó': 'o',
        'ú': 'u',
        'ñ': 'n',
        'Ñ': 'N',
        'Á': 'A',
        'É': 'E',
        'Í': 'I',
        'Ó': 'O',
        'Ú': 'U',
        '&': 'y',
        'ä': 'a',
        'ë': 'e',
        'ï': 'i',
        'ö': 'o',
        'ü': 'u',
        'Ä': 'A',
        'Ë': 'E',
        'Ï': 'I',
        'Ö': 'O',
        'Ü': 'U',
        'à': 'a',
        'è': 'e',
        'ì': 'i',
        'ò': 'o',
        'ù': 'u',
        'À': 'A',
        'È': 'E',
        'Ì': 'I',
        'Ò': 'O',
        'Ù': 'U'
    }

    const result = text.replace(/[áéíóúÁÉÍÓÚ&ñÑ]/g, m => chars[m])
    return result
}

export { emailRegex, replaceTextWithoutAccents }